<template>
    <div ref="graphdiv" style="width: 100%;"></div>
</template>

<script>
import {Dygraph} from '../dygraphs-extra'
import moment from 'moment'
import _ from 'lodash'
  export default {
    props: {
      df: Object
    },
    data() {
      return {
        g: null
      }
    },
    watch: {
      df () {
        this.refresh()
      }
    },
    methods: {
      toImage () {
        return Dygraph.Export.asPNGData(this.g)
      },
      refresh () {
        if(!this.df){
            return;
        }
        let output = []
        for (let i in this.df.timestamp) {
          let row = [ new Date(this.df.timestamp[i].replace(/-/g,'/')) ]
          for(let j in this.df) {
            if(j !== 'timestamp'){
              row.push(this.df[j][i])
            }
          }
          output.push(row)
        }
        let labels=['x']
        for(let k in this.df) {
          if(k !== 'timestamp') {
            labels.push(k)
          }
        }
        if (this.g) {
          this.g.destroy()
        }
        this.g = new Dygraph(
          this.$refs.graphdiv,
          output,
          {labels: labels,
            legend: "always"
          }
        )
          let highlightTime =  _.get(this.$route.query,'highlightTime', null)
          if (highlightTime){
              let annotations=[];
              for(let series of labels){
                  if(series !== "x"){
                      annotations.push({
                          series:series,
                          x: moment(highlightTime).valueOf(),
                          tickHeight: 30,
                          tickColor: 'red',
                          tickWidth: 3,
                      });
                  }
              }
              this.g.setAnnotations(annotations);
          }




      }
    },
    mounted () {
      this.refresh()
    },
    beforeDestroy() {
      if (this.g) {
        this.g.destroy()
      }
    },
    name: 'DygraphsComponent'
  }
</script>

<style scoped>

</style>
